import { supabase } from '../lib/supabase';

/** מזהה המשתמש מהסשן המקומי — כל שליפה מסוננת בו במפורש ולא נשענת על RLS בלבד
 *  (למלווה יש SELECT גם על השקילות של מי ששיתף איתו). */
async function currentUserId(): Promise<string> {
  const { data: { session } } = await supabase.auth.getSession();
  if (!session) throw new Error('no_session');
  return session.user.id;
}

const p = (n: number) => String(n).padStart(2, '0');

/** תאריך מקומי כ-YYYY-MM-DD (לא toISOString — סטיות אזור זמן) */
export function dateKey(d: Date): string {
  return `${d.getFullYear()}-${p(d.getMonth() + 1)}-${p(d.getDate())}`;
}

export function todayLocal(): string {
  return dateKey(new Date());
}

/** שקילה ליום נבחר (ברירת מחדל: היום) — upsert על (user_id, date) */
export async function saveWeightForDate(weightKg: number, day = new Date()): Promise<void> {
  const { data: { session } } = await supabase.auth.getSession();
  if (!session) throw new Error('no_session');
  const { error } = await supabase
    .from('litebite_weights')
    .upsert({ user_id: session.user.id, date: dateKey(day), weight_kg: weightKg }, { onConflict: 'user_id,date' });
  if (error) throw error;
}

export const saveTodayWeight = (weightKg: number): Promise<void> => saveWeightForDate(weightKg);

/** שקילה קיימת בדיוק ליום הנתון, אם יש — לצורך מילוי-מראש בעריכה חוזרת */
export async function fetchWeightForDate(day: Date): Promise<number | null> {
  const userId = await currentUserId();
  const { data, error } = await supabase
    .from('litebite_weights')
    .select('weight_kg')
    .eq('user_id', userId)
    .eq('date', dateKey(day))
    .maybeSingle();
  if (error) throw error;
  return data ? Number(data.weight_kg) : null;
}

export interface LastWeight { date: string; weightKg: number }

/** השקילה האחרונה שנשמרה *לפני* היום הנתון (רמז "המשקל האחרון" כשאין שקילה ליום עצמו) */
export async function fetchLastWeightBefore(day: Date): Promise<LastWeight | null> {
  const userId = await currentUserId();
  const { data, error } = await supabase
    .from('litebite_weights')
    .select('date, weight_kg')
    .eq('user_id', userId)
    .lt('date', dateKey(day))
    .order('date', { ascending: false })
    .limit(1)
    .maybeSingle();
  if (error) throw error;
  return data ? { date: data.date as string, weightKg: Number(data.weight_kg) } : null;
}
